<template>
  <div class="map">
    <div class="map__photo">
      <slot></slot>
    </div>
    <div class="map__map">
      <div class="map__container" :id="id"></div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery';


  const EVENT_YANDEX_MAP_READY_NAME = 'yandexMapReady';

  let apiScriptTag      = null;
  let yandexMapApiReady = false;

  function ymApiReady(onReady) {
    let el;
    let firstScriptTag;

    if (!apiScriptTag) {
      console.log('Yandex maps API initialize...');

      apiScriptTag = true;

      el = document.createElement('script');
      el.setAttribute('charset', 'utf-8');
      el.setAttribute('async', 'async');
      el.setAttribute('src', '//api-maps.yandex.ru/2.1/?lang=ru_RU');

      el.onload = function() {
        console.log('Yandex maps API is ready.');
        yandexMapApiReady = true;
        $(document).trigger(EVENT_YANDEX_MAP_READY_NAME);
      };

      firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(el, firstScriptTag);
    }

    if (typeof onReady === 'function') {
      if (yandexMapApiReady) {
        onReady();
      } else {
        $(document).one(EVENT_YANDEX_MAP_READY_NAME, function() {
          onReady();
        });
      }
    }
  }

  export default {
    props: [
      'id',
      'center',
      'zoom',
    ],

    mounted() {
      console.log('YM mounted');
      let center = this.center || [55.75161665120035, 37.61788699999992];
      let zoom   = this.zoom || 15;

      ymApiReady(() => {
        ymaps.ready(() => {
          console.log(this.id);

          let myMap = new ymaps.Map(this.id, {
            center: center,
            zoom  : zoom,
          });

          myMap.behaviors.disable(['scrollZoom']);

          let myPlacemark = new ymaps.Placemark(myMap.getCenter(), {}, {
            iconLayout     : 'default#image',
            iconImageHref  : '/design/images/point.png',
            iconImageSize  : [67, 89],
            iconImageOffset: [-33, -89],
          });

          myMap.geoObjects.add(myPlacemark);
        });
      });
    },
    data() {
      return {};
    },
  };
</script>



// WEBPACK FOOTER //
// YandexMap.vue?b8b6e0ee